import React from 'react';
import { withNavList } from 'react-skeletal-nav';
import PropTypes from 'prop-types';

import './ExpandedNavList.scss';

const ExpandedNavList = ({ children }) => (
  <ul className="expanded-nav-list">{children}</ul>
);

ExpandedNavList.propTypes = {
  children: PropTypes.node.isRequired
};

export default withNavList(ExpandedNavList);
